export default class SubProduct {
	constructor({ id, name, productId } = {}) {
		this.id = id;
		this.name = name;
		this.productId = productId;
	}

	static buildFromJSON(json) {
		return new SubProduct({
			id: json.id,
			name: json.name,
			productId: json.product
		});
	}

	toJSON() {
		return {
			id: this.id,
			name: this.name,
			product: this.productId
		};
	}

	getId() {
		return this.id;
	}

	getName() {
		return this.name;
	}

	getProductId() {
		return this.productId;
	}
}
